import { render, staticRenderFns } from "./EditProviderInfoModal.vue?vue&type=template&id=61c78420"
import script from "./EditProviderInfoModal.vue?vue&type=script&lang=js"
export * from "./EditProviderInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports